exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-date {\n  display: -ms-flexbox;\n  display: flex; }\n\n.calendar-icon {\n  height: 17px; }\n\n.activate-messega {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  cursor: pointer; }\n  .activate-messega h6 {\n    margin-top: 5px;\n    margin-left: 10px; }\n  .activate-messega .actived {\n    color: #ff9200; }\n  .activate-messega .inactive {\n    color: gray; }\n    .activate-messega .inactive button {\n      border-color: gray;\n      color: gray; }\n\n.spinner-position {\n  position: absolute;\n  z-index: 10000;\n  width: 81%;\n  margin-top: 14%; }\n  .spinner-position small {\n    display: block; }\n\n.enable-opacity-form {\n  opacity: .4;\n  pointer-events: none; }\n\n.disable-opacity-form {\n  opacity: unset;\n  pointer-events: all; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src14910448/src/src/app/components/banners/admin-banners/admin-banners.component.scss
// module id = ../../../../../src/app/components/banners/admin-banners/admin-banners.component.scss
// module chunks = main